import { gql } from '@urql/core';

export const UserProfileFragment = gql`
	fragment UserProfileFragment on GrowthUnifiedProfileResult {
		userProfile {
			userType
			domainType
			teamType
			jobFunction
		}
	}
`;
